/* unplugin-vue-components disabled */import { render } from "./SinglePieChart.vue?vue&type=template&id=601b2c29&scoped=true"
import script from "./SinglePieChart.vue?vue&type=script&lang=js"
export * from "./SinglePieChart.vue?vue&type=script&lang=js"

import "./SinglePieChart.vue?vue&type=style&index=0&id=601b2c29&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601b2c29"]])

export default __exports__